import Ajax from '../ajax'

export default {
  userInfo: () => Ajax('get', 'account/info'),
  childrenInfo: (data) => Ajax('get', 'account/children', data),
  secondRecommendChildren: (data) => Ajax('get', 'account/secondRecommendChildren', data)
}
